<!--
  - Copyright (c) Interactive Information R & D (I2RD) LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - I2RD LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with I2RD.
  -->

<!-- Copied and modified from Passport TextAndHovertext-->
<template>
  <div v-if="text && text.length > truncateWidth" class="text-truncate">
    <v-tooltip top max-width="400">
      <template v-slot:activator="{ on }">
        <span v-on="on">
          {{ text }}
        </span>
      </template>
      <span>
        {{ text }}
      </span>
    </v-tooltip>
  </div>
  <div v-else>
    <span>
      {{ text }}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: ""
    },
    truncateWidth: {
      type: Number,
      default: 20
    }
  }
};
</script>

<style scoped lang="scss"></style>
